import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

import {
  Input,
  Checkbox,
  Category,
  TokenInput,
  DatePicker,
  InputNumber,
  Switch,
  SelectIncludeExclude,
} from 'components/common';

import { formatNumber } from 'utils/number';

const SwitchFilter = styled.div`
  display: flex;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  user-select: none;
  > span {
    margin-left: 8px;
  }
`;

const CheckboxField = ({ value, ...rest }) => (
  <Checkbox {...rest} checked={value} />
);

const NumberField = ({ formatter = formatNumber, ...rest }) => (
  <InputNumber formatter={formatter} {...rest} />
);

// Module-level so every render resolves to the same component type; built inside
// render, the inline wrappers remounted on each keystroke and dropped focus.
const components = {
  input: Input,
  checkbox: CheckboxField,
  token: TokenInput,
  datePicker: DatePicker,
  number: NumberField,
  selectIncludeExclude: SelectIncludeExclude,
  category: Category,
};

const OrgFilterField = ({
  filterId,
  filterType,
  checkValue,
  organisationId,
  onChange,
  formatter,
  getFilter,
  setFilterGroup,
  allowClear = true,
  ...rest
}) => {
  const value = useSelector(getFilter(organisationId, filterId));
  const dispatch = useDispatch();

  const handleChange = value => {
    if (onChange) {
      return onChange(value);
    }

    if (filterType === 'checkbox' && checkValue && value) {
      dispatch(setFilterGroup(organisationId, filterId, checkValue));
      return;
    }

    dispatch(setFilterGroup(organisationId, filterId, value));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const handleSwitchClick = () => {
    if (onChange) {
      return onChange(!value);
    }
    dispatch(setFilterGroup(organisationId, filterId, !value));
  };

  if (filterType === 'switch') {
    return (
      <SwitchFilter onClick={rest.disabled ? undefined : handleSwitchClick}>
        <Switch
          data-testid={`filter-${filterId}`}
          checked={value}
          disabled={rest.disabled}
        />
        <span>{rest.children}</span>
      </SwitchFilter>
    );
  }

  const Component = components[filterType];

  return (
    <Component
      {...rest}
      data-testid={`filter-${filterId}`}
      onChange={handleChange}
      value={value}
      allowClear={allowClear}
    />
  );
};

export default OrgFilterField;
